export default __webpack_public_path__ + "static/media/partner-rebel-bots.88b37f33.webp";